import { faDatabase, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAppDispatch } from "Store/hooks";
import { Button, Popconfirm, Spin } from "antd";
import { setCurrentTenant, setIsModalOpen } from "../redux/slice";
import { initialValues } from "../addEditTenant/intialValues";
import { TenantConstants } from "Constants";
import "Features/Tenants/tenants.index.css";
import { upgradeReposForAllTenants } from "../redux/thunks";
import { setErrorState } from "Components/Basic/ErrorBoundary/redux/slice";
import { useState } from "react";

const TenantToolbar = () => {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const upgradeRepositoryForAllTenants = async () => {
    setIsLoading(true);
    try {
      await dispatch(upgradeReposForAllTenants()).unwrap();
      dispatch(
        setErrorState({
          message: "Success",
          description: "Repository upgraded successfully!",
          placement: "topRight",
          type: "success",
        })
      );
    } catch (ex: any) {
      dispatch(
        setErrorState({
          message: "Error",
          description: ex?.message,
          placement: "topRight",
          type: "error",
        })
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      style={{
        justifyContent: "space-between",
        display: "flex",
        flexDirection: "row-reverse",
        margin: "5px",
        alignItems: "center",
      }}
    >
      <div>
        <Popconfirm
          title={"Are you sure?"}
          description={"Do you want upgrade the repository of all tenants?"}
          onConfirm={() => {
            upgradeRepositoryForAllTenants();
          }}
          okText={"Yes"}
          cancelText={"No"}
        >
          <Button
            type="primary"
            className="add-tenant-button"
            disabled={isLoading}
          >
            {isLoading ? (
              <Spin size="small" style={{ marginRight: 10 }} />
            ) : (
              <FontAwesomeIcon
                style={{ marginRight: "10px" }}
                icon={faDatabase}
              />
            )}
            {isLoading
              ? TenantConstants.UPGRADE_REPOSITORY_FOR_TENANTS
              : "Upgrade Repository for All Tenants"}
          </Button>
        </Popconfirm>
        <Button
          type="primary"
          className="add-tenant-button"
          onClick={() => {
            dispatch(setCurrentTenant(initialValues));
            dispatch(setIsModalOpen(true));
          }}
        >
          <FontAwesomeIcon style={{ marginRight: "10px" }} icon={faPlus} />
          {TenantConstants.ADD_TENANT}
        </Button>
      </div>
      <div className="tenant-heading">Tenants</div>
    </div>
  );
};

export default TenantToolbar;
